export default __webpack_public_path__ + "static/media/ic_slt_go.9de93904.jpg";